import * as React from "react";
import { AttrData } from "../AttributeHistrory.types";

export const AttrDictMulti: React.FC<AttrData> = ({ value }) =>
  value.split(",").join("; ");
